export default [
    {
        path: '/packages',
        name: 'packages-read',
        component: () => import('@/views/packages/package-list/PackageList.vue'),
        meta: {
            resource: 'Packages',
            action: 'read',
        },
    },
    {
        path: '/packages/create',
        name: 'packages-create',
        component: () => import('@/views/packages/package-form/PackageForm.vue'),
        meta: {
          resource: 'Packages',
          action: 'create',
        },
    },
]